<template>
  <v-list-tile>
    <v-dialog v-model="mostrarDialogoDespublicar" persistent max-width="300">
      <az-confirm v-if="mostrarConfirmarDespublicar" :maxWidth=400
                  labelDecline="Cancelar" label-confirm="Confirmar"
                  @onConfirm="confirmarDespublicacao" @onDecline="ocultarDespublicar">
        <div class="texto-modal-habilitacao">
          <label>
            Todas as propostas serão <label style="color: red">excluídas</label>, tem certeza que deseja continuar?
          </label>
        </div>
      </az-confirm>
      <v-list-tile-title slot="activator">
        <v-icon class="material-icons mr-2" small>
          unpublished
        </v-icon>
        Despublicar
      </v-list-tile-title>

      <v-card>
        <v-card-title class="primary modal-title" primary-title>
          Despublicar Licitação
        </v-card-title>
        <v-card-text class="pb-0 az-form-content">
          <div class="az-text mb-3">
            <p><strong>As propostas ativas para o processo serão <label style="color: red !important;">excluídas</label> e o histórico será mostrado na aba eventos pós publicação</strong></p>
            <p>Informe o motivo para despublicar a Licitação</p>
          </div>

          <v-textarea v-model="motivo"
                      :error-messages="errors.collect('Motivo')"
                      v-validate="mostrarDialogoDespublicar? 'required' : ''"
                      :name="'Motivo'"
                      label="Motivo"
                      placeholder="Digite aqui o motivo"
                      rows="3"
                      maxlength="1000"
                      :counter="1000"
                      class="required-field"/>
        </v-card-text>
        <v-card-actions class="acoes justify-center">
          <v-btn color="#777" flat @click="mostrarDialogoDespublicar = false">
            Fechar
          </v-btn>
          <v-btn class="botao-primario confirmar" flat @click="exibirConfirmarDespublicar">
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list-tile>
</template>

<script>
import {mapState} from "vuex";
import {actionTypes} from "@/commons/constants";

export default {
  name: 'AcoesDespublicar',
  data() {
    return {
      motivo: null,
      mostrarDialogoDespublicar: false,
      mostrarConfirmarDespublicar: false
    }
  },
  computed: {
    ...mapState(['licitacao'])
  },
  methods:{
    async exibirConfirmarDespublicar(){
      await this.validarCampos()
      this.mostrarConfirmarDespublicar = true
    },
    ocultarDespublicar(){
      this.mostrarConfirmarDespublicar = false
    },
    async confirmarDespublicacao(){
      this.mostrarConfirmarDespublicar = false
      this.mostrarDialogoDespublicar = false
      await this.$store.dispatch(actionTypes.DESPUBLICAR_LICITACAO, {licitacaoId: this.licitacao.id, motivo: this.motivo})
      document.location.reload(true)
    },
    async validarCampos(){
      const estaValidado = await this.$validator.validateAll()
      if(!estaValidado){
        throw new Error('Preencha todos os campos obrigatórios.')
      }
    }
  }
}
</script>

<style scoped lang="stylus">
.modal-title
  justify-content space-between

  .v-btn
    padding 0
    margin 0
    color #fff
    box-sizing border-box
    min-width 25px

.botao-primario
  padding 0 25px
  border 1px solid #7aa329
  background-color #7aa329 !important
  color #fff !important
  box-sizing border-box
  margin-left 15px !important

.acoes
  padding 20px 0 !important

.painel-item
  box-shadow none
  border-top 1px solid rgba(0, 0, 0, .12)

.painel-titulo
  color #777
  text-align right
</style>
